import { requiredIf, required } from 'vuelidate/lib/validators';
import { phoneAndDashed, phoneCode, empty, phoneAndDashedForUK } from '@/forms/Validations/CommonRules';

import BaseValidation from '@/forms/Validations/BaseValidation';
import ValidationRule from '@/forms/Validations/ValidationRule';

import { names } from '@/common/interfaces/dto/Phone';
export { names } from '@/common/interfaces/dto/Phone';

import { getPhoneCode } from '@/forms/FormElements/Rows/AddressRow/AddressRow.helper';
import { getStore } from '@/store';

interface PhoneParams {
  isRequired?: boolean;
  multiplyPhones?: boolean;
}

export default (path: string = '', params: PhoneParams = {}) => {
  const { isRequired, multiplyPhones } = params;
  const store = getStore()
  const useLongPhone = store.state.Meta.Country === 5 || store.state.Meta.Country === 6
  let rules: ValidationRule[] = [
    {
      name: names.Code,
      rules: {
        ...(isRequired ? { required } : {}),
        requiredIf: requiredIf((function(){
          // @ts-ignore
          if (!this.model.Address) return false
          // @ts-ignore
          return this.model.Address.CountryId !== 385
        })),
        phoneCode,
      },
      messages: {
        ...(isRequired ? { required: 'Enter a phone code' } : {}),
        requiredIf: 'Enter a phone code',
        phoneCode: 'Enter a valid phone code',
      },
      modelValue: getPhoneCode(),
    },
    {
      name: names.Number,
      rules: {
        ...(isRequired ? { required } : {}),
        ...(isRequired && multiplyPhones
          ? {
              requiredMultiple: requiredIf(
                (model: any) => !empty(model[names.Home]) && !empty(model[names.Work]),
              ) as any,
            }
          : {}),
        ...(!isRequired ? { 
          required: requiredIf(function(){
            // @ts-ignore
            if (!this.model.Address) return false
            //@ts-ignore
            return this.model.Address.CountryId !== 385
          }),
         } : {}),
         ...(useLongPhone ? { phoneAndDashedForUK } : phoneAndDashed),
      },
      messages: {
        required: 'Enter a phone number',
        requiredMultiple: 'Enter at least one phone number',
        phoneAndDashed: 'Enter a valid phone number',
      },
    },
  ];

  if (multiplyPhones) {
    rules.push({
      name: names.Home,
      rules: {
        phoneAndDashed,
      },
      messages: {
        phoneAndDashed: 'Enter a valid phone number',
      },
    });
    rules.push({
      name: names.Work,
      rules: {
        phoneAndDashed,
      },
      messages: {
        phoneAndDashed: 'Enter a valid phone number',
      },
    });
  }

  return new BaseValidation(rules, path);
};
